<template>
<div>
    <div :class="['busy-indicator', css]" :style="{ position: position }"></div>
</div>
</template>
<script>
    export default {
		props: {
			position: {
				type: String,
				default: 'relative'
			},
		},
		data() {
			return {
				busy: false,
				showGradientBar: false
			}
		},
        mounted() {
           this.$el.parentElement.style.position = "relative";
		},
		computed: {
			css() {
				return this.busy && this.showGradientBar ? "show-busy-indicator" : "hide-busy-indicator";
			}
		},
		watch: {
			busy() {
                if (this.busy) {
                    setTimeout(() => {
						this.showGradientBar = this.busy;
                    }, 300);
                } else {
					this.showGradientBar = false;
				}
			}
		}
    }
</script>

<style lang="scss">

.show-busy-indicator {
	opacity: 1;
	height: 5px;
}

.hide-busy-indicator {
	opacity: 0;
	height: 0px;
}

.busy-indicator {
    top: 0;
    width: 100%;
	background: linear-gradient(to bottom right,#86fe2b 0%,#2bd4fe 25%,#006b87 50%,#86fe2b 75%,#86fe2b 100%);  
    padding: 0;
    margin: 0;
	display: block;
    background-size: 100% 500%;
    animation: BusyIndicatorGradient 10s infinite;
  }

@keyframes BusyIndicatorGradient {
	0% {
		background-position: 0% 0%
	}
	10% {
		background-position: 0% 50%
	}
	20% {
		background-position: 0% 100%
	}
	30% {
		background-position: 0% 150%
	}
	40% {
		background-position: 0% 200%
	}
	50% {
		background-position: 0% 250%
	}
	60% {
		background-position: 0% 300%
	}
	70% {
		background-position: 0% 350%
	}
	80% {
		background-position: 0% 400%
	}
	90% {
		background-position: 0% 450%
	}
	100% {
		background-position: 0% 500%
	}
}

</style>



// WEBPACK FOOTER //
// src/framework/primitives/BusyIndicator.vue